import * as React from 'react';
export function ensureElement(child) {
  var tagName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';
  if (React.isValidElement(child)) {
    return child;
  }
  if (typeof child === 'string') {
    return child.trim().length > 0 ? React.createElement(tagName, {}, child) : React.createElement(tagName);
  }
  if (typeof child === 'number') {
    return React.createElement(tagName, {}, child);
  }
  return React.createElement(tagName, {});
}